module.exports = __webpack_public_path__ + "img/Conflict Confronter.88895bfd.svg";